// Distance formatting utility
export const formatDistance = (km) => {
  if (!km && km !== 0) return null; // Handle cases where distance might be undefined

  if (km * 1000 < 950) {
    // Show in meters if less than 950m
    return `${Math.round(km * 1000)} m`;
  }
  // Otherwise, show in kilometers with one decimal place
  return `${km.toFixed(1)} km`;
};

// Distance calculation utility
export const calculateDistance = (lat1, lon1, lat2, lon2) => {
  const R = 6371; // Radius of the earth in km
  const dLat = deg2rad(lat2 - lat1);
  const dLon = deg2rad(lon2 - lon1);
  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(deg2rad(lat1)) * Math.cos(deg2rad(lat2)) *
    Math.sin(dLon / 2) * Math.sin(dLon / 2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  return R * c; // Distance in km
};

// Helper function for distance calculation
export const deg2rad = (deg) => deg * (Math.PI / 180); 